export const SvgWhatsapp = (props) => {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_1214_14403)">
				<path
					d="M18.0035 0.95166H17.995C8.59401 0.95166 0.949219 8.59858 0.949219 18.0017C0.949219 21.7313 2.15124 25.1882 4.19511 27.9951L2.07026 34.3292L8.62385 32.2341C11.3199 34.0201 14.5359 35.0517 18.0035 35.0517C27.4044 35.0517 35.0492 27.4026 35.0492 18.0017C35.0492 8.60072 27.4044 0.95166 18.0035 0.95166Z"
					fill="#33B338"
				/>
				<path
					d="M27.925 25.0285C27.5137 26.19 25.8812 27.1533 24.579 27.4347C23.6881 27.6243 22.5244 27.7757 18.6072 26.1517C13.5966 24.0758 10.3699 18.9843 10.1184 18.6539C9.87761 18.3236 8.09375 15.9579 8.09375 13.5112C8.09375 11.0645 9.33627 9.87317 9.83711 9.36167C10.2484 8.94181 10.9283 8.75 11.5805 8.75C11.7915 8.75 11.9811 8.76066 12.1516 8.76918C12.6525 8.79049 12.904 8.82033 13.2343 9.61103C13.6457 10.6021 14.6473 13.0487 14.7667 13.3002C14.8882 13.5517 15.0097 13.8927 14.8392 14.223C14.6793 14.564 14.5386 14.7154 14.2872 15.0052C14.0357 15.2951 13.797 15.5167 13.5455 15.8279C13.3153 16.0985 13.0553 16.3884 13.3451 16.8892C13.635 17.3794 14.6367 19.0141 16.1115 20.3269C18.0147 22.0213 19.5577 22.5626 20.1097 22.7928C20.5211 22.9633 21.0113 22.9228 21.3118 22.6031C21.6933 22.1918 22.1643 21.5098 22.6438 20.8384C22.9848 20.3568 23.4153 20.2971 23.8671 20.4676C24.3275 20.6275 26.7635 21.8316 27.2643 22.081C27.7652 22.3325 28.0955 22.4518 28.217 22.6628C28.3364 22.8738 28.3364 23.8648 27.925 25.0285Z"
					fill="#FAFAFA"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1214_14403">
					<rect
						width="34.1"
						height="34.1"
						fill="white"
						transform="translate(0.949219 0.95166)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
